import React, { useState, useMemo, useCallback } from 'react'

import type { AxiosError } from 'axios'

import { AlertWithTitle } from '~/components/AlertWithTitle'
import { formatAxiosError } from '~/helpers/errors'

const useErrorApiAlert: UseErrorApiAlert<AxiosError> = ({ title = 'Erro' }) => {
  const [errorRaw, setErrorRaw] =
    useState<AxiosError<APIErrorRawResponse> | null>(null)

  const error = useMemo(
    () => (errorRaw ? formatAxiosError(errorRaw) : null),
    [errorRaw]
  )

  const closeAlert = useCallback(() => {
    setErrorRaw(null)
  }, [])

  const component: React.FC<AlertComponentProps> = ({ type = 'critical' }) => {
    if (!error) return null

    return (
      <AlertWithTitle
        style={{ margin: '1rem 0' }}
        title={title}
        description={error || ''}
        onDismiss={closeAlert}
        variant={type}
      />
    )
  }

  return [component, setErrorRaw]
}

export { useErrorApiAlert }
